import { writable } from 'svelte/store';
import { refreshUserSession } from '../../app.logic';
export const loading = writable(false);
//export const record = writable<ICustomizableRegionSettingsDTO>(null);
export const record = writable(null);
let initialized = false;
export async function init() {
    if (!initialized) {
        initialized = true;
        //record.set(null);
    }
    await loadRegionSettings();
}
export async function loadRegionSettings() {
    loading.set(true);
    try {
        //let _resp = await SettingsService.fetchCustomizableRegionSettings();
        //record.set(_resp.payload);
    }
    finally {
        loading.set(false);
    }
}
export async function save() {
    //let _record = get(record);
    //await SettingsService.saveCustomizableRegionSettings(_record);
    await loadRegionSettings();
    // reload user session to update header
    await refreshUserSession();
}
